import React, { useEffect, useState } from 'react';
import { LinkOutlined, StopOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';
import BtnSimpl from '../../components/buttons/BtnSimpl';
import "./formulaires.css";
import { Alert, Button, Card, Col, Row, } from 'antd';
import { MdEditOff } from 'react-icons/md';
import QuestionItem from '../../components/forms/QuestionItem';



const FormPreview = () => {
  const [previewData, setPreviewData] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("previewForm");
    if (stored) {
      const data = JSON.parse(stored);
      setPreviewData(data);
    }
  }, []);

  return (
    <div className="divGFormPrv">
      <div className='stylDivTop'>
        <Row justify="center">
          <Col span={4} style={{ marginLeft: "-6.5%" }}>
            <Title level={4}>Mode aperçu</Title>
          </Col>
          <Col span={19} className='stylColRight'>
            <Title level={5} style={{ margin: 0 }}>
              <StopOutlined /> Non publié
            </Title>
            <BtnSimpl
              padding_="7%"
              color_="#43CE0C"
              boldColor_={500}
              buttonText_="Copier le lien pour les répondants"
              htmlType_="button"
              border_={true}
              prefix_={<LinkOutlined />}
            />
          </Col>
          <Col span={23}>
            <Alert
              icon={<MdEditOff />}
              showIcon
              message="Ce formulaire n'accepte pas de réponses."
              type="warning"
              style={{ border: "none", textAlign: "left" }}
            />
          </Col>
        </Row>
      </div>

      <div className='stylDivContent'><br/>
        {previewData ? (
          <>
            <Row justify="center"  style={{ marginBottom:"1.2%", }}>
                <Col span={12}>
                    <Card className='stylCardTitleDesc'>
                        <div style={{textAlign:"left"}}>
                            <Title level={2} style={{margin:0,}}>{previewData.title || "Formulaire sans titre"}</Title>
                            <Title level={4}>{previewData.description || "Description du formulaire"}</Title>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Row justify="center">
                <Col span={12}>
                     {previewData.questions.map((q, index) => (
                        <Card key={`${q.id}-${index}`} style={{ marginBottom:"2.5%",textAlign:"left", }} >
                            <span style={{ fontSize:"12pt" }}>{q.label || `Question ${index + 1}`}</span>
                           <QuestionItem
                                question={q}
                                isCollapsed={true}
                            />
                        </Card>
                    ))}
                </Col>
                
            </Row>
            <Row justify="center">
                <Col
                    span={12}
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <div>
                    <Button
                        disabled
                        style={{ border: "none", fontWeight:600 }}
                        title="Impossible d'envoyer des formulaires en mode aperçu"
                    >
                        Envoyer
                    </Button>
                    </div>
                    <div>
                    <Button type="text" style={{ color: "#43CE0C", fontWeight:600  }}>
                        Effacer le formulaire
                    </Button>
                    </div>
                </Col>
                </Row>
          </>
        ) : (
          <p style={{ textAlign: "center", marginTop: 50 }}>Aucun formulaire à afficher.</p>
        )}
      </div>
    </div>
  );
};

export default FormPreview;
